import React from 'react';
import {connect} from "react-redux";
import AuthService from "../../../../../../services/AuthService";
import DeleteIcon from 'material-ui/svg-icons/action/delete-forever';
import Slider from 'material-ui/Slider';
import ArrowUpIcon from 'material-ui/svg-icons/hardware/keyboard-arrow-up';
import ArrowDownIcon from 'material-ui/svg-icons/hardware/keyboard-arrow-down';
import {
    getActivitesPrincipales,
    setActivitesPrincipales
}from './../../../../../../actions/entreprise/actions_entreprise_entretien';
import AutoComplete from "material-ui/AutoComplete/index";

class ActivitesPrincipalesTable extends React.Component {

    constructor(props){
        super(props);
        this.state = {
            t1Open:false,
            t1AutoComplete:[],
            searchText:''
        };
        this.Auth = new AuthService();
        this.fetchActivitesPrincipales = this.fetchActivitesPrincipales.bind(this);
        this.persistActivitesPrincipales = this.persistActivitesPrincipales.bind(this);
        this.deleteActivite = this.deleteActivite.bind(this);
        this.handleNewActivite = this.handleNewActivite.bind(this);
    }

    persistActivitesPrincipales(){
        const activites = this.props.activites_principales;
        this.Auth.fetch('/salarie/activites_poste_actuel',{
            method:'PUT',
            data:activites
        });
    }

    handleNewActivite(x){
        const eh = this.props.entretienHeader;
        this.Auth.fetch('/salarie/activites_poste_actuel',{
            method:'POST',
            data:{
                id_salarie: eh.id_salarie,
                id_entretien: eh.id,
                id_entreprise: eh.id_entreprise,
                activite:x,
                pourcentage:0
            }
        }).then( x=>{
            this.fetchActivitesPrincipales();
            this.setState({t1Open:true, searchText:''});
        });
    }

    fetchActivitesPrincipales(){
        const id_entretien = this.props.entretienHeader.id;
        this.props.dispatch(getActivitesPrincipales(id_entretien));
    }

    deleteActivite(id_activite){
        this.Auth.fetch(`/salarie/activites_poste_actuel/${id_activite}`,{
            method:'delete'
        }).then(x=>this.fetchActivitesPrincipales());
    }
    componentDidUpdate(prevProps, prevState, snapshot){
        if(prevProps.entretienHeader !== this.props.entretienHeader )
            this.fetchActivitesPrincipales();
    }
    componentDidMount(){
        if(this.props.entretienHeader && this.props.entretienHeader.id){
            this.fetchActivitesPrincipales();
        }
        this.Auth.fetch('/societe/activites_poste_actuel')
            .then(x=> this.setState({t1AutoComplete:x.data.payload}))
    }



    render() {
        let sumPourcentages = 0;
        if(this.props.activites_principales && this.props.activites_principales.length > 0){
            sumPourcentages = this.props.activites_principales.map(x=> parseInt(x.pourcentage, 10)).reduce((x,y)=> x+y);
        }

        let left = 100 - sumPourcentages;
        return (
            <div>
                <AutoComplete
                    hintText="Activités principales du salarié dans son poste actuel"
                    floatingLabelText="Activités principales"
                    filter={AutoComplete.caseInsensitiveFilter}
                    dataSource={this.state.t1AutoComplete}
                    searchText={this.state.searchText}
                    onUpdateInput={(text)=>this.setState({searchText:text})}
                    onNewRequest={(x)=>this.handleNewActivite(x)}
                    fullWidth={true}
                    maxSearchResults={5}
                />
                <table className="table table-sm table-hover">
                    <thead className="thead-light" style={{cursor:'pointer'}} onClick={()=>this.setState({t1Open:!this.state.t1Open})}>
                    <tr>
                        <th scope="col">Activités principales</th>
                        <th width="210" scope="col">{this.state.t1Open ? 'Pourcentage de l\'activité '+sumPourcentages+' %' : ''}</th>
                        <th width="35" style={{textAlign:'right'}} scope="col">{this.state.t1Open ? <ArrowUpIcon/> : <ArrowDownIcon/>}</th>
                    </tr>
                    </thead>
                    <tbody>
                    {this.state.t1Open && this.props.activites_principales.map(x=>{
                        return (
                            <tr key={x.id}>
                                <td>{x.activite}</td>
                                <td>
                                    <Slider
                                        min={0}
                                        max={parseInt(x.pourcentage, 10) + left}
                                        sliderStyle={{margin:0}}
                                        step={1}
                                        value={parseInt(x.pourcentage, 10)}
                                        onDragStop={this.persistActivitesPrincipales}
                                        onChange={(p1,p2)=>this.props.dispatch(setActivitesPrincipales(this.props.activites_principales.map(y=>{
                                            if(y.id === x.id){
                                                return {
                                                    ...y, pourcentage:''+p2
                                                }
                                                }else{
                                                return y;
                                                }
                                                })))}
                                    />
                                    {x.pourcentage + " %"}
                                    </td>
                                <td style={{textAlign:'right'}}>
                                    <DeleteIcon style={{cursor:'pointer'}} onClick={()=>this.deleteActivite(x.id)} color='red' />
                                </td>
                            </tr>);
                        })}
                        </tbody>
                </table>
            </div>
        );
    }
}

function mapStateToProps(store) {
    return {
        entretienHeader: store.entretien.header,
        activites_principales: store.entretien.activites_principales
    }
}

export default connect(mapStateToProps)(ActivitesPrincipalesTable);


// WEBPACK FOOTER //
// ./src/components/entreprise/bodies/entretiens/passer_entretien/comps/ActivitesPrincipalesTable.js